/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Grid, Icon, Dropdown } from 'semantic-ui-react';
import _ from 'lodash';

import { getVideo } from '../../fbApi/Videos';
import * as AppActions from '../../actions';
import './CarouselCard.css';

class CarouselCard extends Component {
  state = {
    token: this.props.getFbToken(),
    ctaOptions: [],
    image_url: '',
    videoUrl: '',
    video: ''
  };

  componentDidMount() {
    this.fillCtaOptions();

    if (this.props.card && this.props.edit) {
      this.initializeEdit();
    }
  }

  initializeEdit = () => {
    let cardId = this.props.card.id;

    this.setState({
      image_url: this.props.card.image_url,
      video: this.props.card.video
    });
    this.getVideoUrl(this.props.card.video);
  };

  fillCtaOptions = async () => {
    const options = ['LEARN_MORE'];
    const ctaOptions = _.sortBy(
      _.map(options, (op, index) => ({
        key: index,
        value: op,
        text: op
      })),
      'text'
    );
    this.setState({ ctaOptions });
  };

  removeCard = () => {
    this.props.removeCard(this.props.cardNumber);
  };

  handleCardChange = (event, { name, value }) => {
    this.setState({ name: value });
    this.props.handleCardChange(event, { name, value });
  };

  handleImageChange = (event, { name, value }) => {
    this.setState({ image_url: value });
    this.props.handleCardChange(event, { name, value });
  };

  handleVideoChange = (event, { name, value }) => {
    this.setState({ video: value });
    event = { target: { id: this.props.cardNumber } };
    this.getVideoUrl(value).then((data) => {
      this.props.handleCardChange(event, { name, value });
    });
  };

  getVideoUrl = async (asset) => {
    const video = await getVideo(asset, this.state.token);
    const assetPreview = video && video.source ? video.source : '';
    this.setState({ videoUrl: assetPreview });
    return assetPreview;
  };

  moveLeft = () => {
    this.props.swapCard(this.props.cardNumber, 'left');
  };

  moveRight = () => {
    this.props.swapCard(this.props.cardNumber, 'right');
  };

  render() {
    return (
      <div>
        {this.props.card ? (
          <div className="carrousel-card-container">
            <h3>Product {this.props.cardNumber}</h3>
            <div className="arrows-container">
              {this.props.cardNumber !== 1 ? (
                <a className="arrow-icon" onClick={this.moveLeft}>
                  <Icon size="large" name="arrow alternate circle left" />
                </a>
              ) : null}
              {this.props.cardNumber !== this.props.totalCards ? (
                <a className="arrow-icon" onClick={this.moveRight}>
                  <Icon size="large" name="arrow alternate circle right" />
                </a>
              ) : null}
            </div>
            {this.props.cardNumber !== 1 ? (
              <a className="remove-card" onClick={this.removeCard}>
                <Icon size="large" name="trash" />
              </a>
            ) : null}
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <div className="asset-container">
                    <img
                      src={this.state.image_url}
                      className="card-asset-container"
                    />
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="asset-container">
                    {this.state.videoUrl ? (
                      <video
                        width="100%"
                        controls
                        loop
                        autoPlay
                        className="card-asset-container"
                      >
                        <source src={this.state.videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    ) : null}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Form.Input
              className="carrousel-card-input-name"
              placeholder={'Product ' + this.props.cardNumber + ' Image URL'}
              type="text"
              name="image_url"
              id={this.props.cardNumber}
              defaultValue={this.props.card.image_url}
              value={this.props.card.image_url}
              onChange={this.handleImageChange}
            />
            <Form.Input
              className="carrousel-card-input-name extra-space"
              placeholder={'Product ' + this.props.cardNumber + ' Video ID'}
              type="text"
              name="video"
              id={this.props.cardNumber}
              defaultValue={this.state.video}
              value={this.state.video}
              onChange={this.handleVideoChange}
            />
            <Form.Input
              className="carrousel-card-input-name"
              placeholder={'Product ' + this.props.cardNumber + ' Name'}
              type="text"
              name="cardName"
              id={this.props.cardNumber}
              defaultValue={this.props.card.cardName}
              value={this.props.card.cardName}
              onChange={this.handleCardChange}
            />
            <Form.Input
              className="carrousel-card-input-name extra-space"
              placeholder={'Product ' + this.props.cardNumber + ' Description'}
              type="text"
              name="description"
              id={this.props.cardNumber}
              defaultValue={this.props.card.description}
              value={this.props.card.description}
              onChange={this.handleCardChange}
            />
            <Form.Input
              className="carrousel-card-input-name"
              placeholder={'Product ' + this.props.cardNumber + ' Link'}
              type="text"
              name="link"
              id={this.props.cardNumber}
              defaultValue={this.props.card.link}
              value={this.props.card.link}
              onChange={this.handleCardChange}
            />
            <Dropdown
              label="Call To Action"
              className="cta-options"
              placeholder="Call To Action"
              search
              selection
              value={this.props.card.call_to_action}
              options={this.state.ctaOptions}
              onChange={this.onCtaSelect}
            />
          </div>
        ) : (
          <div className="carrousel-card-container">
            <div className="add-icon">
              <a className="card-icon" onClick={this.props.addCard}>
                <Icon size="huge" name="plus circle" />
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CarouselCard);



// WEBPACK FOOTER //
// ./src/screens/Carousel/CarouselCard.js